import { desaturate } from 'polished';

const theme = {
  brandRed: '#e61919',
  brandRedHover: '#b81414',
  brandBlack: '#262626',
  textColor: '#dfdfdf',
  gutter: '2rem',
  transition: '250ms cubic-bezier(.02, .01, .47, 1)',
  footerHeight: '6.777777778rem',
  breakpoints: {
    mobile: '26.67rem'
  }
};

export { theme };



// WEBPACK FOOTER //
// ./src/components/theme.js